import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20office%20desk%20setup%20with%20a%20large%20monitor%20displaying%20security%20dashboard%20graphs%20and%20verification%20checkmarks%20warm%20ambient%20desk%20lamp%20lighting%20dark%20wood%20surface%20with%20neat%20cable%20management%20professional%20trustworthy%20atmosphere%20high%20detail%20editorial%20corporate%20photography%20clean%20composition%20no%20text%20no%20logos%20no%20people&width=800&height=600&seq=safety-v2-2026&orientation=landscape"
                alt="OOPBuy Spreadsheet safety"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <p className="text-xs md:text-sm text-foreground-500 tracking-wider mb-3 whitespace-nowrap">
              / Safety First
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6 leading-tight">
              Is OOPBuy Spreadsheet Safe?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                Yes, when used correctly, OOPBuy Spreadsheet systems are designed to reduce risk by providing verified product listings, tracking complete order history, and minimizing direct seller interaction risks that commonly lead to issues in traditional shopping.
              </p>
              <div className="bg-accent-50 border border-accent-200/60 rounded-xl p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-accent-400 mt-0.5">
                    <i className="ri-information-line text-foreground-950 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">Important Safety Tips</h4>
                    <ul className="space-y-1.5 text-xs md:text-sm text-foreground-600">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-accent-500 mt-0.5"></i>
                        Always verify product details before placing orders
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-accent-500 mt-0.5"></i>
                        Avoid unknown or unverified sellers
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-accent-500 mt-0.5"></i>
                        Use trusted platform links only
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-accent-500 mt-0.5"></i>
                        Keep track of all order confirmations
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <Link
                to="/article/oopbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Read full safety guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}